export default __webpack_public_path__ + "static/media/EPFL2.d32feba1.png";